import { render, staticRenderFns } from "./BookingAdmin.vue?vue&type=template&id=0f569061&scoped=true"
import script from "./BookingAdmin.vue?vue&type=script&lang=js"
export * from "./BookingAdmin.vue?vue&type=script&lang=js"
import style0 from "./BookingAdmin.vue?vue&type=style&index=0&id=0f569061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f569061",
  null
  
)

export default component.exports